module.exports = __webpack_public_path__ + "67ddcddbac52ddbc73f15c1b68ff8111.gif";


//////////////////
// WEBPACK FOOTER
// ./components/app/products/product-label-preview/loading.gif
// module id = 690
// module chunks = 0